export default "__VITE_ASSET__v77YiepU__"